import { useEffect, useState } from "react";
import axios from "axios";
import { Star } from "lucide-react";
import { API } from "../../config";

export const ReviewsSection = ({ lang }) => {
  const [rows, setRows] = useState([]);
  useEffect(() => { axios.get(`${API}/web-design/reviews`).then((r) => setRows(r.data.rows)).catch(() => {}); }, []);
  if (!rows.length) return null;
  return (
    <section className="max-w-6xl mx-auto px-5 sm:px-8 py-16" data-testid="web-funnel-reviews">
      <h2 className="text-2xl sm:text-3xl font-black mb-8">{lang === "cs" ? "Co říkají zákazníci" : "Čo hovoria zákazníci"}</h2>
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
        {rows.map((r) => (
          <figure key={r.id} className="rounded-2xl border border-white/10 bg-white/[0.03] p-5" data-testid={`web-review-${r.id}`}>
            <div className="flex gap-0.5">{[1, 2, 3, 4, 5].map((n) => <Star key={n} className={`w-4 h-4 ${n <= r.rating ? "fill-[#a3e635] text-[#a3e635]" : "text-white/20"}`} />)}</div>
            <blockquote className="mt-3 text-white/85">„{r.text}“</blockquote>
            <figcaption className="mt-4 text-sm text-white/60">{r.author}{r.company ? ` · ${r.company}` : ""}
              {r.website && <> · <a href={/^https?:\/\//.test(r.website) ? r.website : `https://${r.website}`} target="_blank" rel="noopener noreferrer" className="underline hover:text-[#a3e635]">{r.website.replace(/^https?:\/\//, "")}</a></>}</figcaption>
          </figure>
        ))}
      </div>
    </section>
  );
};
